import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { PredefinedNomination } from '@/modules/predefined/enums/PredefinedNomination';

export class EstateNomination extends BaseEntityModel {
  id?: number;
  estateId?: number;
  userId?: number;
  nominationId?: number;

  constructor(model: Partial<EstateNomination> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.userId = model.userId;
    this.nominationId = model.nominationId;
  }

  get nomination(): PredefinedNomination | undefined {
    return PredefinedNomination.getByKey(this.nominationId, 'id');
  }
}
